@if (loading() && fullScreen()) {
  <app-full-screen-loader [loaderText]="message()" />
} @else {
  <p-dialog
    [closable]="false"
    [closeOnEscape]="false"
    [dismissableMask]="false"
    [maskStyleClass]="opaque() ? 'velocity-loader-mask' : undefined"
    [modal]="true"
    [visible]="loading()"
  >
    <ng-template #headless>
      @if (image()) {
        <div class="loadscreen-container-image">
          <img [src]="image()" alt="loading" />
        </div>
      }
      <div class="loadscreen-container">
        <img
          class="load-screen-image"
          src="assets/animated/svg/loader-3-circle.svg"
          alt="loading"
          height="20px"
        />
        <p class="loadscreen-message">{{message()}}</p>
      </div>
    </ng-template>
  </p-dialog>
}
